import {Tooltip, TooltipProps} from 'antd';
import {QuestionCircleTwoTone} from '@ant-design/icons';
import {CSSProperties} from "react";

export default function HelpTooltip({tooltip, iconStyle}: { tooltip?: TooltipProps, iconStyle?: CSSProperties}) {
  return <Tooltip {...tooltip}>
    <QuestionCircleTwoTone style={{fontSize: '1.5rem', ...iconStyle}}/>
  </Tooltip>;
}